import { AnimatePresence, motion } from "framer-motion";
import logo from "../img/logo.svg";

const messages = {
  en: "Switching language, please wait...",
  de: "Sprache wird gewechselt, bitte warten...",
  pl: "Zmiana języka, proszę czekać...",
  jp: "言語を切り替えています、お待ちください...",
};

function LangSwitchOverlay({ lang }) {
  return (
    <AnimatePresence>
      {lang && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.2 } }}
          exit={{ opacity: 0, transition: { duration: 0.35 } }}
          className="fixed inset-0 z-[9998] flex items-center justify-center bg-[#05193A]"
        >
          <motion.div
            initial={{ scale: 0.88, opacity: 0, y: 16 }}
            animate={{ scale: 1, opacity: 1, y: 0, transition: { duration: 0.3, ease: "easeOut" } }}
            exit={{ scale: 0.92, opacity: 0, y: 8, transition: { duration: 0.2 } }}
            className="flex flex-col items-center gap-[24px] rounded-[24px] bg-[#0c2d6b] px-[60px] py-[44px] text-center shadow-[0_32px_80px_rgba(0,0,0,0.45)]"
          >
            <img src={logo} alt="" className="w-[130px]" />
            <div className="flex items-center gap-[10px]">
              {[0, 1, 2].map((i) => (
                <span
                  key={i}
                  className="block h-[8px] w-[8px] rounded-full bg-[#DAEBFC]"
                  style={{ animation: `lang-bounce 1.2s ease-in-out ${i * 0.18}s infinite` }}
                />
              ))}
            </div>
            <p className="font-['Nunito_Sans'] text-[15px] font-light leading-[1.6] text-[#DAEBFC]">
              {messages[lang] ?? messages.en}
            </p>
          </motion.div>
          <style>{`
            @keyframes lang-bounce {
              0%, 80%, 100% { transform: translateY(0); opacity: 0.4; }
              40% { transform: translateY(-10px); opacity: 1; }
            }
          `}</style>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default LangSwitchOverlay;
